import * as Types from '../../../../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendUserFeedbackMutationVariables = Types.Exact<{
  data: Types.SendUserFeedbackInput;
}>;


export type SendUserFeedbackMutation = { __typename: 'Mutation', sendUserFeedback: { __typename: 'UserFeedback', id: string } };


export const SendUserFeedbackMutationDocument = gql`
    mutation sendUserFeedbackMutation($data: SendUserFeedbackInput!) {
  sendUserFeedback(data: $data) {
    id
  }
}
    `;

/**
 * __useSendUserFeedbackMutation__
 *
 * To run a mutation, you first call `useSendUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUserFeedbackMutation, { data, loading, error }] = useSendUserFeedbackMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendUserFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendUserFeedbackMutation, SendUserFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendUserFeedbackMutation, SendUserFeedbackMutationVariables>(SendUserFeedbackMutationDocument, options);
      }
export type SendUserFeedbackMutationHookResult = ReturnType<typeof useSendUserFeedbackMutation>;